<div class="space-y-6 contact-page-container w-[100%]">
  <div class="contact-page-header mb-0 w-[80vw]">
    <h2 class="text-2xl font-semibold">CONTACT US</h2>
  </div>
  <div class="contact-page-content-wrapper bg-gray-100 border-gray-200 border-t flex justify-center w-[100%]">
    <div class="contact-details-container w-[80vw]">
      <div>
        <h3 class="contact-section-title text-lg font-semibold text-black border-l-4 pl-2  border-green-700">Information
          inquiry</h3>
        <p class="mt-1 text-gray-700">
          For any general queries,contact us at : <a href="mailto:global.cib.indices.support&#64;bnpparibas.com"
            class="text-green-700 underline"> global.cib.indices.support&#64;bnpparibas.com
          </a>
        </p>
      </div>
      <div class="mt-10">
        <h3 class="contact-section-title text-lg font-semibold text-black border-l-4 pl-2 border-green-700">
          Complaint procedure
        </h3>
        <p class="mt-1 text-gray-700">
          To file a complaint please contact us at : <a href="mailto:global.cib.indices.support&#64;bnpparibas.com"
            class="text-green-700 underline"> global.cib.indices.support&#64;bnpparibas.com
          </a>
        </p>
        <div *ngFor="let item of documentsForComplaintInfo()" class="resource-wrapper">
          <a href="javascript:void(0)"  class="inline-flex items-center px-3 py-1 -ml-2  text-black text-sm font-medium rounded gap-3" (click)="onDownloadDocument(item)">
            <span>Complaint procedure documentation</span>
            <img width="25px" height="29px" src="{{ deployUrlHost }}/assets/PDF_icon.png" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
